module.exports = __webpack_public_path__ + "4e0c9294b0695e74108b0edbceff291c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/organizations/hero_bg@2x.jpg
// module id = 661
// module chunks = 0